import joi from 'joi';

import {
  type PathLookupCheck,
  type PathLookupPassingTraffic,
  pathLookupPassingTraffic,
} from '../pathLookup';
import type { WithSnapshot } from '../snapshot';
import {
  type GraphPathLookupParameters,
  graphPathLookupParametersSchema,
} from './GraphPathLookupParameters';
import {
  type GraphRequestSettings,
  graphRequestSettingsSchema,
} from './GraphRequest';

interface PathLookupChecksRequestBodyBase {
  settings?: GraphRequestSettings;
  parameters: GraphPathLookupParameters;
}

export type PathLookupCheckExistsRequestBody = PathLookupChecksRequestBodyBase;

export interface PathLookupChecksRequestBody
  extends PathLookupChecksRequestBodyBase {
  expectedPassingTraffic: PathLookupPassingTraffic;
}

const pathLookupChecksRequestBodyBaseSchema = joi.object().keys({
  settings: graphRequestSettingsSchema,
  parameters: graphPathLookupParametersSchema.required(),
});

export const pathLookupCheckExistsRequestBodySchema =
  pathLookupChecksRequestBodyBaseSchema;

export const pathLookupChecksRequestBodySchema =
  pathLookupChecksRequestBodyBaseSchema.keys({
    expectedPassingTraffic: joi
      .string()
      .valid(...pathLookupPassingTraffic)
      .required(),
  });

interface PathLookupChecksMeta extends WithSnapshot {
  count: number;
  limit: number | null;
  size: number;
  start: number;
}

export interface PathLookupChecksResponseBody {
  data: PathLookupCheck[];
  _meta: PathLookupChecksMeta;
}

export interface PathLookupCheckExistsResponseBody {
  exists: boolean;
  expectedPassingTraffic?: PathLookupPassingTraffic;
}
